// constants
import { ContactPersonActionTypes } from './constants';
import { ContactPerson as ContactPersonData } from 'src/types/contactPerson';

export type ContactPersonActionType = {
    type:
        | ContactPersonActionTypes.API_RESPONSE_SUCCESS
        | ContactPersonActionTypes.API_RESPONSE_ERROR
        | ContactPersonActionTypes.GET_CONTACT_PERSON
        | ContactPersonActionTypes.ADD_CONTACT_PERSON
        | ContactPersonActionTypes.EDIT_CONTACT_PERSON
        | ContactPersonActionTypes.GET_CONTACT_PERSONS
        | ContactPersonActionTypes.RESET
        | ContactPersonActionTypes.RESET_SUCCESS
        | ContactPersonActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const contactPersonApiResponseSuccess = (
    actionType: string,
    data: ContactPersonData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ContactPersonActionType => ({
    type: ContactPersonActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const contactPersonApiResponseError = (
    actionType: string,
    data: ContactPersonData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ContactPersonActionType => ({
    type: ContactPersonActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addcontactPerson = (params: any): ContactPersonActionType => ({
    type: ContactPersonActionTypes.ADD_CONTACT_PERSON,
    payload: params,
});

export const editContactPerson = (params: any): ContactPersonActionType => ({
    type: ContactPersonActionTypes.EDIT_CONTACT_PERSON,
    payload: params,
});

export const getContactPerson = (params: any): ContactPersonActionType => ({
    type: ContactPersonActionTypes.GET_CONTACT_PERSON,
    payload: params,
});

export const getContactPersons = (params: any): ContactPersonActionType => ({
    type: ContactPersonActionTypes.GET_CONTACT_PERSONS,
    payload: params,
});

export const resetContactPerson = (): ContactPersonActionType => ({
    type: ContactPersonActionTypes.RESET,
    payload: {},
});

export const resetContactPersonSuccess = (): ContactPersonActionType => ({
    type: ContactPersonActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetContactPersonError = (): ContactPersonActionType => ({
    type: ContactPersonActionTypes.RESET_ERROR,
    payload: {},
});
